<div class="company-list-page" *ngIf="!isNotificationView">
  <app-portlet [config]="portletConfig" [buttons]="portletButtons">
    <app-common-grid
      [config]="gridConfig"
      [data]="gridData"
      [loading]="(loading$ | async) || false"
      [apiEndpoint]="apiEndpoint"
      [gridId]="gridId"
      [autoHeight]="true"
      [offsetHeight]="140"
      [minHeight]="400"
      [maxHeight]="1000"
      [enableDetailGrid]="true"
      [showGridFilter]="true"
      [filterFields]="filterFields"
      [filterConfig]="filterConfig"
      (dataStateChange)="onDataStateChange($event)"
      (gridFilterChange)="onFilterChange($event)"
    ></app-common-grid>
  </app-portlet>
</div>

<div *ngIf="isNotificationView">
  <div class="p-3">
    <div class="d-flex align-items-center justify-content-between">
      <p class="mb-0 fs-15 fw-medium">Notifications</p>
      <span class="badge bg-secondary text-fixed-white" id="notifiation-data"
        >{{ gridData['total'] }} Unread</span
      >
    </div>
  </div>
  <div class="dropdown-divider"></div>
  <overlay-scrollbars>
    <ul class="list-unstyled mb-0" id="header-notification-scroll">
      <li
        *ngFor="let item of gridData.data"
        ngbDropdownItem
        class="dropdown-item"
        id="row{{ item['id'] }}"
      >
        <button
          (click)="handleFinishFromlistSigning(item['id'], item['fileId'])"
          class="border-0 bg-transparent"
        >
          <div class="d-flex align-items-start">
            <div class="flex-grow-1 d-flex align-items-start justify-content-between">
              <div class="d-flex align-items-start justify-content-start flex-column">
                <p class="mb-0 fw-medium">
                  <a href="javascript:void(0);">{{ item['fileName'] }}</a>
                </p>
                <div class="text-muted fw-normal fs-12 header-notification-text text-truncate">
                  <span class="text-primary">{{ item['syncstr'].split(' ')[2] }}</span> has
                  {{ item['isRequest'] ? 'requested' : 'shared' }} a file **{{
                    item['fileName']
                  }}**.
                </div>
                <div class="fw-normal fs-10 text-muted op-8">
                  {{ item['syncstr'] }}
                </div>
              </div>
            </div>
          </div>
        </button>
      </li>
    </ul>
  </overlay-scrollbars>
</div>
